import React, { useEffect, useState, useMemo } from 'react'
// import WorkflowPhasesPage from '../../../../Operations/Scenes/Workflows/Components/WorkflowPhasesPage'
import WorkflowPhasesPage from '../../../Operations/Scenes/Workflows/Components/WorkflowPhasesPage';
import GetWorkflowMainCategoryService from '../../../../../../Service/OPSServices/WorkflowsService/GetWorkflowMainCategoryService';
import { connect } from 'react-redux';

function ProjectsDashWorkFlowsMainPage(props) {
    const [workflowPhasesList,setWorkflowPhasesList]=useState()
    const [workflowMainCategory, setWorkflowMainCategory] = useState("");

    // const [selectedStoreData, setSelectedStoreData] = useState({
    //     integerId: "",
    //     storeName: "",
    //   });
      const selectedStoreData = useMemo(() => {
        return {
          integerId: props.selectedProjectData &&props.selectedProjectData.integerId || '',
          storeName: props.selectedProjectData &&props.selectedProjectData.storeName || ''
        };
      }, [props.selectedProjectData]);
    useEffect(()=>{
        console.log(props.selectedProjectData);
        // setSelectedStoreData({integerId:props.selectedProjectData.integerId,
        //     storeName:props.selectedProjectData.storeName
        //     }
        // )
        GetWorkflowMainCategoryService(props.token).then((res)=>{
            console.log(res);
            setWorkflowMainCategory(res.masterWorkflows);
            const filteredPhases = res.workflowPhases && res.workflowPhases.filter(phase => phase.WorkflowsMaster == props.selectedProjectData.workflowsId).sort((a, b) => a.id - b.id);
            setWorkflowPhasesList(filteredPhases)
            console.log(filteredPhases);
        })

    },[])
  return (

  <>
  <div className="ml-3">
    <WorkflowPhasesPage 
    flag={false}
    selectedWorkflowMasterId={props.selectedProjectData.workflowsId}
    workflowPhases={workflowPhasesList}
    selectedProjectData={props.selectedProjectData}
    workflowMainCategory={workflowMainCategory}
    selectedStoreData={selectedStoreData}
    key={workflowPhasesList}
    hideBackButton={true}
    />
  </div>
  </>
  )
}
const mapStateToProps = state => {
    return {
      token: state.loggedUser.token,
      accessLevel: state.loggedUser.accessLevel,
      status: state.loggedUser.status,
    }
  }
  
  export default connect(mapStateToProps)(ProjectsDashWorkFlowsMainPage);
